exports.components = {
  "component---src-pages-busqueda-jsx": () => import("./../../../src/pages/busqueda.jsx" /* webpackChunkName: "component---src-pages-busqueda-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

